import SideMenu from './SideMenu'
import { Outlet } from 'react-router-dom'
import { LogoutOutlined } from '@ant-design/icons'
import { useUserContext } from '../components/contexts/UserContext'
import type { PopconfirmProps } from 'antd';
import { Layout, Popconfirm, message, Button } from 'antd'

const { Sider } = Layout


const AppLayout = () => {

  const { updateUser } = useUserContext()

  const confirm: PopconfirmProps['onConfirm'] = () => {

    updateUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("imToken");

    message.success('Амжилттай гарлаа');
  };

  const cancel: PopconfirmProps['onCancel'] = () => {
    message.error('Болих');
  };

  return (
    <div className='app-layout custom'>
      <Layout style={{ minHeight: '100vh' }}>
        <Sider theme="light">
          <div className='fixed flex-col flex justify-between h-full max-w-[250px]'>
            <div className='flex-col'>
              <div className="flex h-16 w-full items-center justify-center gap-3 border-b p-4">
                <a href="/">
                  <img alt='logo' src='https://e-mongolia.mn/static/assets/22f0de95a94e0ff1f5198e7275ff0813.svg' />
                </a>
              </div>
              <SideMenu />

            </div>
            <div className='text-xs text-gray-400 px-6 text-center pb-6'>
              2024 <a href="https://nextsocial.mn" target="_blank" rel="noreferrer" className='underline'>
                Некст Сошиал Платформ ХХК
              </a> платформ ©  Хөгжүүлсэн
            </div>
          </div>
        </Sider>
        <Layout>
          <div className='flex items-center justify-end pr-12 bg-white h-16 p-4 border-b border-b-gray-200'>
            {/* header */}
            <Popconfirm
              title="Гарах"
              description="Энэ үйлдлийг хийхдээ итгэлтэй байна уу ?"
              onConfirm={confirm}
              onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button className='flex items-center justify-center gap-3 border border-gray-300 w-fit px-4 py-1 rounded-full hover:cursor-pointer hover:bg-gray-300 transition-all'>
                Гарах
                <LogoutOutlined />
              </Button>
            </Popconfirm>

          </div>
          <div className='py-4 px-6'>
            <Outlet />
          </div>
        </Layout>
      </Layout>
    </div>
  )
}

export default AppLayout
